import './AgrementFgaz.scss';

import cn from 'classnames';
import React from 'react';
import { Trans } from 'react-i18next';

import { ReactComponent as WarningIcon } from '@/materiaux/assets/icons/warning.svg';

import {
  AgrementFgazDefaultProps,
  AgrementFgazPropTypes,
} from './AgrementFgaz.proptypes';

const AgrementFgaz = ({ agrementFgaz, className }) => {
  if (agrementFgaz) {
    return (
      <div className={cn('agrement-fgaz', className)}>
        <WarningIcon className="agrement-fgaz__icon" />
        <span className="agrement-fgaz__description">
          <Trans
            allowHTML
            i18nKey="ebat:entities:product.details.agreement_fgaz"
            values={{ agrement: agrementFgaz }}
          />
        </span>
      </div>
    );
  }

  return null;
};

AgrementFgaz.defaultProps = {
  ...AgrementFgazDefaultProps,
};

AgrementFgaz.propTypes = {
  ...AgrementFgazPropTypes,
};

export default AgrementFgaz;
